<template>
    <div class="page-deliver-todo">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">同城配送</div>
            <div class="breadcrumb-item">交收記錄(已簽收)</div>
        </div>
        <Form>
            <FormItem style="display: none">
                <Select size="large" placeholder="操作人" v-model="form.admin_id" style="width:100%">
                    <Option :value="item.user_id" v-for="(item, index) in pickAdmin"
                            :key="item.user_id">{{item.username}} ({{item.realname}})
                    </Option>
                </Select>
            </FormItem>
        </Form>
        <div class="card-block pd-bt">
            <Menu mode="horizontal" active-name="4" width="auto" class="layout-l-menu">
                <MenuItem name="1" to="/samecityList">
                    <!-- <Icon type="ios-paper" /> -->
                    全部
                </MenuItem>
                <MenuItem name="2" to="/samecityListToDo">
                    <!-- <Icon type="ios-people" /> -->
                    待交收, 到店/櫃
                </MenuItem>
                <MenuItem name="3" to="/samecityListShop">
                    <!-- <Icon type="ios-construct" /> -->
                    到店/櫃
                </MenuItem>
                <MenuItem name="4" to="/samecityListSigned">
                    <!-- <Icon type="ios-construct" /> -->
                    已簽收
                </MenuItem>
            </Menu>
            <br>
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <Table size="small"
                   :row-class-name="rowClassName"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">

                <template slot-scope="{ row, index }" slot="status">
                    <span v-if="row.status == 0">待交件</span>
                    <span v-else-if="row.status == 1">待交件</span>
                    <span v-else-if="row.status == 2">運送中</span>
                    <span v-else-if="row.status == 3">到店/櫃</span>
                    <span v-else-if="row.status == 4">客戶簽收</span>
                </template>

                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handlePrintCode(row)">【印】</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="11" class="pagger-left">
                        <div class="pagger-total">總共 {{totalCount}} 條記錄</div>
                    </Col>
                    <Col span="13" class="pagger-right">
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import Store from '../../../assets/js/store.js';
    export default {
        data() {
            return {
                theme1: 'light',
                sc_name: '',
                sc_id: '',
                sc_user_id: '',
                sc_store_id: '',
                sc_balance: '',
                pdfUrl: '',
                pageIndex: 1,
                curPageSize: 10,
                totalCount: 1,
                pageInput: '',
                pickAdmin: [],
                form: {
                    admin_id: Store.fetch().user_id,
                    sack_number: '',
                    odd_numbers: ''
                },
                isSubmiting: false,
                table: {
                    column: [
                        {
                            title: '貨物位置',
                            key: 'receivingName',
                            align: 'center',
                            sortable: true,
                            minWidth: 120
                        },
                        {
                            title: '出貨單號',
                            key: 'odd_numbers',
                            align: 'center',
                            sortable: true,
                            minWidth: 280
                        },
                        {
                            title: '入件日期',
                            key: 'created_at',
                            align: 'center',
                            sortable: true,
                            minWidth: 150
                        },
                        {
                            title: 'KG',
                            key: 'weight',
                            align: 'center',
                            sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '到付($)',
                            key: 'freight_collect',
                            align: 'center',
                            sortable: true,
                            minWidth: 80
                        },
                        {
                            title: '貨物狀態',
                            key: 'status',
                            align: 'center',
                            slot: 'status',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '收費方式',
                            key: 'type',
                            align: 'center',
                            sortable: true,
                            minWidth: 100
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 80
                        },
                    ],
                    data: []
                }
            };
        },
        created()
        {
            this.getPickAdmin();
        },
        mounted()
        {
            let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
            if(logInfo.userparent != null){
                this.sc_name = logInfo.userparent.mark;
                this.sc_id = logInfo.userparent.id;
                this.sc_balance = logInfo.userparent.balance;
                this.sc_user_id = logInfo.user_id;
                this.sc_store_id = logInfo.store_id;
            }
            this.getList();
        },
        activated()
        {
            this.getPickAdmin();
            let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
            if(logInfo.userparent != null){
                this.sc_name = logInfo.userparent.mark;
                this.sc_id = logInfo.userparent.id;
                this.sc_balance = logInfo.userparent.balance;
                this.sc_user_id = logInfo.user_id;
                this.sc_store_id = logInfo.store_id;
            }
            this.getList();
        },
        methods: {
            rowClassName (row, index) {
                if (row.status === 1) {
                    return 'status-one';
                } 
                else if (row.status === 2) {
                    return 'status-two';
                }
                else if (row.status === 3) {
                    return 'status-three';
                }
                else if (row.status === 4) {
                    return 'status-four';
                }
                return '';
            },
            formatDate(datetime)
            {
                if (!datetime) return '';
            
                let dateTime = new Date(datetime);
                let year = dateTime.getFullYear();
                let month = dateTime.getMonth() + 1;
                let date = dateTime.getDate();
                let hour = dateTime.getHours();
                let minute = dateTime.getMinutes();
                let second = dateTime.getSeconds();
                let milliseconds = dateTime.getMilliseconds();
                return `${this.formatNum(year)}-${this.formatNum(month)}-${this.formatNum(date)} ${this.formatNum(hour)}:${this.formatNum(second)}:${this.formatNum(milliseconds)}`;
            },
            formatNum(num)
            {
                return num < 10 ? '0' + num : num;
            },
            getPickAdmin()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAdmin,
                    method: 'post'
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.pickAdmin = res.data.data;
                    }
                });
            },
            getList()
            {
                let form = this.form;
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.samecityList,
                    method: 'get',
                    data: {
                        status: 4,
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize, 
                        goods_type: 2, //同城快遞
                        odd_numbers: form.odd_numbers,
                        sack_number: form.sack_number,
                        admin_id: form.admin_id
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let type_name;
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {

                            if(resData[i].type == 1){
                                type_name = '收方付費'; 
                            }
                            else if(resData[i].type == 2){
                                type_name = '商家餘額'; 
                            }
                            else if(resData[i].type == 3){
                                type_name = '商家月結'; 
                            }

                            tempArr.push({
                                id: resData[i].id,
                                recipient_contacts: resData[i].recipient_contacts,
                                created_at: resData[i].created_at,
                                odd_numbers: resData[i].odd_numbers,
                                count: resData[i].count,
                                weight: resData[i].weight,
                                type: type_name,
                                remarks: resData[i].remarks,
                                arrive: resData[i].arrive,
                                arrive_type: resData[i].arrive_type,
                                receivingName: resData[i].store ? resData[i].store.ReceivingName : '無',
                                status: resData[i].status,
                                actor: resData[i].admininfo.realname,
                                recipient_phone: resData[i].recipient_phone,
                                freight_collect: resData[i].freight_collect,
                            });
                        }

                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },
            handleExport() {
                let token = localStorage.getItem('jyb_token');
                let logInfo = localStorage.getItem('jyb_logInfo') ? JSON.parse(localStorage.getItem('jyb_logInfo')) : {};
                let adminuser;

                if(logInfo.userparent.id == null || logInfo.userparent.id == 0){
                    this.$Utils.showTipInfo("該商家用戶錯誤");
                }
                else{
                    adminuser = logInfo.userparent.id;
                }

                let form = this.form;
                let params = {
                    status: 1,
                    parent_id: adminuser,
                    arrive: form.arrive,
                    phone: form.recipient_phone,
                    name: form.recipient_contacts,
                    type: form.type,
                    odd_numbers: form.odd_numbers,
                    arrive_init: form.arrive_init,
                    start_time: this.formatDate(form.start_time),
                    end_time: this.formatDate(form.end_time),
                    Authorization: token,
                };
                let formatParams = this.$Utils.formateObjToParamStr(params);
                window.open(`${this.$Api.samecityListExcel}?${formatParams}`, '_blank');
            },
            handlePrintCode(row)
            {
                let type_number;
                if(row.type == '收方付費'){
                    type_number = 1; 
                }
                else if(row.type == '商家餘額'){
                    type_number = 2; 
                }
                else if(row.type == '商家月結'){
                    type_number = 3; 
                }
                let params = {
                    type: type_number,
                    arrive: row.arrive,
                    weight: row.weight,
                    courier: '',
                    courier_tel: '',
                    odd_numbers: row.odd_numbers,
                    recipient_contacts: row.recipient_contacts,
                    recipient_phone: row.recipient_phone,
                    freight_collect: Number(row.freight_collect) ? Number(row.freight_collect): 0,
                    parent_id: this.sc_id,
                    store_id: this.sc_store_id,
                    user_id: this.sc_user_id,
                    remarks: row.remarks,
                };
                this.pdfUrl = this.$Api.samecityorderprint + '?' + this.$Utils.formateObjToParamStr(params);
                window.open(this.pdfUrl);
            },
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style>
    .ivu-table .status-one td{
        background-color: rgba(0,255,0,0.3);
        color: #fff;
    }
    .ivu-table .status-two td{
        background-color: rgba(0,255,0,0.3);
        color: #fff;
    }
    .ivu-table .status-three td{
        background-color: rgba(255,255,0,0.3);
        color: #fff;
    }
    .ivu-table .status-four td{
        background-color: rgba(255,0,0,0.3);
        color: #fff;
    }
</style>

<style lang="scss" scoped>
    @import "samecityListSigned.scss";
</style>